// src/components/ProductQuickView.tsx
import React from 'react';
import { Modal, Descriptions, Button, Image, Divider } from 'antd';

type AnyItem = Record<string, any>;

interface Props {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  item: (AnyItem & { category: string }) | null;
}

const ProductQuickView: React.FC<Props> = ({ open, onClose, onEdit, item }) => {
  if (!item) return null;

  const title = [item.brand, item.partNumber, item.model]
    .filter(Boolean)
    .join(' ')
    .trim();

  const firstImg =
    Array.isArray(item.images) && item.images.length > 0 ? item.images[0] : null;

  const typeLabel =
    item.original === 'original'
      ? 'Оригинал'
      : item.original === 'copy'
      ? 'Копия'
      : '';

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={title || 'Товар'}
      width={720}
      destroyOnHidden 
    >
      <div style={{ display: 'flex', gap: 16 }}>
        <div style={{ width: 260 }}>
          {firstImg ? (
            <Image src={firstImg} alt={title} width={260} />
          ) : (
            <div
              style={{
                width: 260,
                height: 260,
                background: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 8,
              }}
            >
              Нет изображения
            </div>
          )}
        </div>

        <div style={{ flex: 1 }}>
          <Descriptions column={1} size="middle" bordered>
            <Descriptions.Item label="Категория">{item.category}</Descriptions.Item>
            <Descriptions.Item label="Бренд">{item.brand || '—'}</Descriptions.Item>
            <Descriptions.Item label="Номер детали">{item.partNumber || '—'}</Descriptions.Item>
            <Descriptions.Item label="Модель">{item.model || '—'}</Descriptions.Item>
            <Descriptions.Item label="Тип товара">{typeLabel || '—'}</Descriptions.Item>
            {'price' in item && (
              <Descriptions.Item label="Цена">
                {item.price != null ? `${item.price} ֏` : '—'}
              </Descriptions.Item>
            )}
            {'quantity' in item && (
              <Descriptions.Item label="Количество">
                {item.quantity ?? '—'}
              </Descriptions.Item>
            )}
          </Descriptions>

          <Divider />

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={onClose}>Закрыть</Button>
            <Button type="primary" onClick={onEdit}>Редактировать</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProductQuickView;
